import {
  ParcelSchema,
  type IParcel,
} from "@redotech/redo-fulfillment-parcel-common/parcel";
import * as z from "zod";
import { null as zNull } from "zod";

export const createParcels = {
  name: "createParcels" as const,
  input: z.object({ parcels: z.array(ParcelSchema as IParcel) }),
  output: zNull(),
};
